import AppConstants from '../constants/AppConstants';
import store from '../stores/redux';
import api from '../api';
import handleError from '../helpers/requestErrorHandler';

const { dispatch } = store;
const defEvents = {
    before: AppConstants.LINKS_START_LOADING,
    success: AppConstants.LINKS_SEARCH_SUCCESS,
    fail: AppConstants.LINKS_FAIL
};

let lastSignature = null;
let pendingTimeout = null;

const LinksActions = {
    getListLinks(params, callback, events = defEvents) {
        const signature = JSON.stringify(params || {});
        if (signature === lastSignature && !pendingTimeout) {
            return;
        }
        if (pendingTimeout) {
            clearTimeout(pendingTimeout);
            pendingTimeout = null;
        }

        if (events.before) {
            dispatch({
                type  : events.before
            });
        }

        pendingTimeout = setTimeout(() => {
            pendingTimeout = null;
            lastSignature = signature;

            api.searchLinks(params)
                .then(data => {
                    if (events.success) {
                        dispatch({
                            type: events.success,
                            items: data.response || {}
                        });
                    }

                    callback && callback(data.response);
                })
                .catch(err => {
                    handleError(err, () => {
                        dispatch({
                            type: events.fail,
                            error: err
                        });
                    });
                });
        }, 0);
    },

    saveLinkPresets(params) {
        return api.saveLinkPresets(params);
    },

    updateShortUrl(params) {
        return api.updateShortUrl(params);
    },

    getShortUrl(params, callback, events = defEvents) {
        api.getShortUrl(params)
            .then(data => {
                if (callback) callback(data);
            })
            .catch(error => {
                console.error('Error during short URL creation:', error);
            });
    },

    getShortenerDomainList(params, callback, events = defEvents) {
        api.getShortenerDomainList(params)
            .then(data => {
                if (callback) callback(data);
            })
            .catch(error => {
                console.error('Error during get shortener domain list:', error);
            });
    },

    getQRCode(params, callback, events = defEvents) {
        api.getQRCode(params)
            .then(data => {
                if (callback) callback(data);
            })
            .catch(error => {
                console.error('Error during QR code generation:', error);
            });
    }
};

export default LinksActions;
